
<template>
  <div class="main-border">
    <v-row class="pb-5">
      <v-col
        cols="6"
        md="4"
        :class="
          $route.params.vista_id == 1 ? 'text-center active-color' : 'text-center inactive-color'
        "
        @click="$router.push('/main-hub/1')"
      >
          <span
            :class="
              $route.params.vista_id == 1
                ? 'text-header-step-active'
                : 'text-header-step-no-active'
            "
          > Mis solicitudes</span>
      </v-col>
      <v-col
        cols="6"
        md="4"
        :class="
          $route.params.vista_id == 2 ? 'text-center active-color' : 'text-center inactive-color'
        "
        @click="$router.push('/main-hub/2')"
      >
          <span
            :class="
              $route.params.vista_id == 2
                ? 'text-header-step-active'
                : 'text-header-step-no-active'
            "
          > Mis Pólizas</span>
      </v-col>
      <v-col
        cols="6"
        :md="globalConfig.showQuotesDashboard ? 3 : 4"
        :class="
          $route.params.vista_id == 3 ? 'text-center active-color' : 'text-center inactive-color'
        "
        @click="$router.push('/main-hub/3')"
      >
          <span
            :class="
              $route.params.vista_id == 3
                ? 'text-header-step-active'
                : 'text-header-step-no-active'
            "
          >Mis Clientes</span>
      </v-col>
    </v-row>
    <div>
      <div v-if="$route.params.vista_id == 1">
        <solicitudes-index></solicitudes-index>
      </div>
      <div v-if="$route.params.vista_id == 2">
        <polizas-index></polizas-index>
      </div>
      <div v-if="$route.params.vista_id == 3">
        <clientes-index></clientes-index>
      </div>
    </div>
  </div>
</template>
<script>
import SolicitudesIndex from "./solicitudes/Dasboard/SolicitudesIndex.vue";
import PolizasIndex from "./polizas/Dashboard/PolizasIndex.vue";
import ClientesIndex from "./clientes/Dashboard/ClientesIndex.vue";

export default {
  components: {
    SolicitudesIndex,
    PolizasIndex,
    ClientesIndex,
  },
  data() {
    return {
      tab: 1,
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")) ?? {},
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
    };
  },
  methods: {

  },
  computed:{
  },
  mounted(){
    this.isAlianza ? this.tab = 5 : this.tab = 4;
    this.isAlianza ? this.alianza_id = this.$route.params.alianza_id : ''
  }
};
</script>
